export default __webpack_public_path__ + "static/media/Group1278Tata@2x.40eb4e0c.png";